module.exports = __webpack_public_path__ + "static/media/associati_pcarchitetti.e7aa2137.jpeg";